import FinalCalculation from './FinalCalculation';
import Product from './Product';
import Reference from './Reference';

export default class SiMaxPrice {
	reference: Reference;

	products: Product[];

	finalCalculation: FinalCalculation;

	links: { [key: string]: string };

	constructor(
		reference: Reference,
		products: Product[],
		finalCalculation: FinalCalculation,
		links: { [key: string]: string }
	) {
		this.reference = reference;
		this.products = products;
		this.finalCalculation = finalCalculation;
		this.links = links;
	}

	getExportXlsLink(): string {
		return this.links['export-xls'];
	}
}
